<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯与小米击了个掌！</div>
      <div class="news-date">2024年9月25日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          挥挥手，欢迎回家。
        </p>
        <p>
          最近，鹅的好伙伴小米发布新款智能门锁M30 Pro，正在让手掌成为钥匙。在这背后，正是鹅厂的黑科技——
          <span class="mark-text highlight">“刷掌技术”</span>。
        </p>
        <p>
          基于腾讯优图实验室自研的“掌纹+掌静脉”AI能力，鹅厂的刷掌技术经过了海量实际应用测试，实力那叫一个硬。
        </p>
        <p>
          此次小米智能门锁M30 Pro采用的掌静脉识别技术，简单来说，就是通过近红外光照射穿透皮肤，捕捉手掌皮下静脉血管图像信息。正如世界上没有两片相同的树叶，掌静脉也具有唯一性，让开锁更便捷、更安全。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news52.gif"/>
          </div>
        </div>
        <p>
          但在皮下复杂的血管网络中精准、快速、安全地识别静脉图像并不容易：开锁前要反复练习解锁姿势吗？距离怎么控制？光照强弱有影响吗……
        </p>
        <p>
          任何一个细节把控不好，达不到伸掌秒开，都会让用户感觉“麻烦”。毕竟，谁想下班后还要与门锁“对齐”？！
        </p>
        <p>
          最关键的是，世上手掌千千万，AI要如何充分学习，才能认准“唯一”？
        </p>
        <div class="news-content-mark">
          <div>1  给手掌来个“大广角”</div>
        </div>
        <p>
          通过鹅厂扩大视场角、抗运动模糊拍摄、实时质量优选、光线滤除和可控补光能力等黑科技，消除了外界环境（比如光线强弱）影响。
        </p>
        <p>
          在较大范围内（9cm-20cm），旋转、倾斜、挥动……你手掌的各种姿势都能被精准识别， 
          <span class="mark-text highlight">准确率高达99.9999%以上</span>。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news52/news52_1.gif"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>2  用AI训练AI</div>
        </div>
        <p>
          没有丰富的学习资料，就很难有聪明的AI。但刷掌数据稀缺，怎么办？AI的事情让Ta自己干！
        </p>
        <p>
          腾讯优图实验室为此自研了模型生成算法，即用AI生成的图像代替手掌样本用以算法模型训练，让模型训练更省时、模型生成更高效。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news52/news52_2.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>3  没有相似只有唯一</div>
        </div>
        <p>
          在保障门锁安全上，鹅厂也下了一番“苦功夫”。
        </p>
        <p>
          比如通过“全局与局部结合识别方案”，可以准确区分出高度相似的掌静脉的细节差异，即使是是同卵双胞胎，没有事先“对齐”也会被拒之门外。
        </p>
        <p>
          同时，小米智能门锁M30 Pro还搭载了金融级算法模型，
          <span class="mark-text highlight">可有效防御手掌照片、视频等十多种动静态素材的攻击</span>。
        </p>
        <p>
          不只是M30 Pro，小米门锁M30系列新品均采用了腾讯云的相关技术，让用户回家便捷开锁，安全又高效。
        </p>
        <p>
          下一个，就等你了，来跟鹅击个掌吧！
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News52',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News52.vue